import { Button, Empty, Form, Input, Radio } from '@maxtropy/components';
import React, { useMemo } from 'react';
import styles from '../index.module.scss';
import { ChartDayData, ChartHourData, DateType, DateValue, DeviceRankItem, RightStatisticData } from '../types';
import dayjs from 'dayjs';
import TimeAxis from './TimeAxis';
import Chart from './Chart';
import StatisticsCard from './StatisticCard';
import { DoubleRightOutlined } from '@ant-design/icons';
import { isEmpty } from 'lodash-es';

interface RightAreaProp {
  pageLabel?: string;
  dateRange?: DateValue;
  selectedDevice?: DeviceRankItem;
  rightStatisticData?: RightStatisticData;
  dateType?: DateType;
  chartDayData?: ChartDayData;
  chartHourData?: ChartHourData;
  onChangeViewDimension: (dimension: DateType) => void;
}

const RightArea = ({
  pageLabel,
  dateRange,
  dateType,
  selectedDevice,
  rightStatisticData,
  chartDayData,
  chartHourData,
  onChangeViewDimension,
}: RightAreaProp) => {
  // 图表数据
  const chartData = useMemo(() => {
    if (dateType === DateType.DAY) {
      return (
        chartDayData?.dataList?.map((item, index) => ({
          time: item.ts,
          totalAmount: item.usage,
          longFlowAmount: item.conditionUsage,
          nonLongFlowAmount: item.unConditionUsage,
          longFlowProportion: item.conditionProportion,
          nonLongFlowProportion: item.unConditionProportion,
        })) || []
      );
    }
    return (
      chartHourData?.dataList?.map((item, index) => ({
        ...item,
        time: item.ts,
        totalAmount: item.flow || 0,
        longFlowAmount: item.flag ? item.flow : null,
        nonLongFlowAmount: item.flag ? null : item.flow,
      })) || []
    );
  }, [chartDayData, chartHourData, dateType]);

  return (
    <div className={styles.rightArea}>
      <StatisticsCard pageLabel={pageLabel} selectedDevice={selectedDevice} statistics={rightStatisticData} />
      {isEmpty(selectedDevice) ? (
        <Empty style={{ marginTop: 100 }} />
      ) : (
        <>
          <TimeAxis pageLabel={pageLabel} data={rightStatisticData?.dataList} />
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Radio.Group buttonStyle="solid" value={dateType} onChange={e => onChangeViewDimension(e.target.value)}>
              <Radio.Button value={DateType.HOUR}>按小时</Radio.Button>
              <Radio.Button value={DateType.DAY}>按日</Radio.Button>
            </Radio.Group>
            <Button
              style={{ padding: 0 }}
              type="link"
              onClick={() => {
                window.open(`/data/history/device?deviceId=${selectedDevice?.deviceId}`, '_blank');
              }}
            >
              详情
              <DoubleRightOutlined />
            </Button>
          </div>
          <Chart pageLabel={pageLabel} chartData={chartData} queryTimeRanges={dateRange} dateType={dateType!} />
        </>
      )}
    </div>
  );
};

export default RightArea;
